export enum RestApiConditionType {
    Variable = 'Variable',
    HttpCode = 'HttpCode',
    Logical = 'Logical',
}
